<template>
	<div class="mall-shop-page">
		<shop-workbench-nav active-key="manage" />
		<div class="shop-panel goods-manage-panel">
			<div class="goods-manage-tabs">
				<div class="goods-state-tabs">
					<div
						v-for="item in stateTabs"
						:key="item.key"
						class="goods-state-tab"
						:class="{ active: activeStateTab === item.key }"
						@click="handleStateTabChange(item)"
					>
						{{ item.label }}<span v-if="item.key === 'selling' && activeStateTab === 'selling'">（{{ pageOptions.total }}）</span>
					</div>
				</div>
				<div class="draft-entry" :class="{ active: activeStateTab === 'draft' }" @click="handleStateTabChange(draftTab)">
					<i class="el-icon-message"></i>
					<span>草稿箱</span>
				</div>
			</div>

			<div class="goods-filter-bar">
				<el-form :inline="true" :model="queryParams" class="goods-search-form" label-width="78px">
					<el-form-item label="商品名称：" class="goods-search-title">
						<el-input v-model="queryParams.goodsTitle" clearable />
					</el-form-item>
					<el-form-item label="商品类型：" class="goods-search-select">
						<el-select v-model="queryParams.goodsType" clearable placeholder="">
							<el-option label="平台自营商品" :value="1" />
							<el-option label="展销商品" :value="2" />
						</el-select>
					</el-form-item>
					<el-form-item label="上架时间：" class="goods-search-date">
						<el-date-picker
							v-model="shelfTimeRange"
							type="daterange"
							start-placeholder=""
							end-placeholder=""
							value-format="yyyy-MM-dd"
							range-separator="至"
							clearable
						/>
					</el-form-item>
					<el-form-item label="商品状态：" class="goods-search-select">
						<el-select v-model="queryParams.rowState" clearable placeholder="">
							<el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item class="goods-search-actions">
						<el-button type="primary" @click="handleSearch">查询</el-button>
						<el-button @click="handleReset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

			<el-table v-loading="loading" :data="tableData" border class="goods-manage-table">
				<el-table-column label="商品信息" min-width="430">
					<template slot-scope="{ row }">
						<div class="goods-info-cell">
							<el-image class="goods-cover" :src="getGoodsImage(row)" fit="cover">
								<div slot="error" class="goods-cover-placeholder">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
							<div class="goods-info-text">
								<div class="goods-title">{{ row.goodsTitle || row.title || '-' }}</div>
								<div class="goods-code">订单编号：{{ row.orderCode || '-' }}</div>
								<el-button type="text" class="goods-preview-btn" @click="handleDetail(row)">预览&gt;</el-button>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="类目" width="150">
					<template slot-scope="{ row }">{{ categoryText(row) }}</template>
				</el-table-column>
				<el-table-column label="售价" width="120">
					<template slot-scope="{ row }">
						<span v-if="Number(row.priceType) === 2">面议</span>
						<span v-else>{{ priceText(row) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="累计销量" width="110">
					<template slot-scope="{ row }">{{ row.salesVolume || row.salesCount || row.saleCount || 0 }}</template>
				</el-table-column>
				<el-table-column label="商品状态" width="120">
					<template slot-scope="{ row }">
						<span class="status-pill" :class="statusClass(row.rowState)">{{ goodsStatusText(row) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="订单审核状态" width="120">
					<template slot-scope="{ row }">
						<span class="status-pill" :class="auditClass(row)">{{ auditStatusText(row) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="支付状态" width="120">
					<template slot-scope="{ row }">
						<span class="status-pill" :class="orderStateClass(row.orderState)">{{ orderStateText(row.orderState) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="上架时间" width="180">
					<template slot-scope="{ row }">
						<div class="time-cell">{{ timeText(row) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220" fixed="right">
					<template slot-scope="{ row }">
						<el-button type="text" @click="handleDetail(row)">详情</el-button>
						<el-button v-if="Number(row.rowState) === 7" type="text" @click="handleEdit(row)">编辑</el-button>
						<el-button v-if="Number(row.rowState) === 8" type="text" @click="handleUpdateState(row, 9)">下架</el-button>
						<el-button v-if="[7, 9].includes(Number(row.rowState))" type="text" @click="handleUpdateState(row, 2)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="goods-pagination">
				<el-pagination
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="pageOptions.total"
					:current-page.sync="pageOptions.page"
					:page-size.sync="pageOptions.limit"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import ShopWorkbenchNav from './components/WorkbenchNav.vue'
	import { previewMerchantFile, queryMyMerchantGoodsPage, updateMerchantGoodsState } from '@/api/mall'

	export default {
		name: 'MallGoodsManage',
		components: { ShopWorkbenchNav },
		data() {
			return {
				loading: false,
				tableData: [],
				pageOptions: {
					page: 1,
					limit: 20,
					total: 0
				},
				activeStateTab: 'all',
				shelfTimeRange: [],
				queryParams: {
					goodsTitle: '',
					goodsType: '',
					rowState: ''
				},
				stateTabs: [
					{ key: 'all', label: '全部', rowState: '' },
					{ key: 'selling', label: '售卖中', rowState: 8 },
					{ key: 'off', label: '已下架', rowState: 9 },
					{ key: 'auditing', label: '审核中', rowState: 1 },
					{ key: 'reject', label: '审核驳回', rowState: 3 },
					{ key: 'pass', label: '审核通过', rowState: 4 }
				],
				draftTab: { key: 'draft', label: '草稿箱', rowState: 7 },
				stateOptions: [
					{ label: '售卖中', value: 8 },
					{ label: '已下架', value: 9 },
					{ label: '审核中', value: 1 },
					{ label: '审核驳回', value: 3 },
					{ label: '审核通过', value: 4 },
					{ label: '草稿', value: 7 }
				]
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			async loadData() {
				this.loading = true
				try {
					const params = {
						page: this.pageOptions.page,
						size: this.pageOptions.limit,
						...this.queryParams,
						startShelfTime: this.shelfTimeRange && this.shelfTimeRange[0] ? this.shelfTimeRange[0] : '',
						endShelfTime: this.shelfTimeRange && this.shelfTimeRange[1] ? this.shelfTimeRange[1] : ''
					}
					const res = await queryMyMerchantGoodsPage(params)
					const data = res.data || {}
					this.tableData = data.records || data.list || []
					this.pageOptions.total = Number(data.total || this.tableData.length || 0)
				} finally {
					this.loading = false
				}
			},
			handleSearch() {
				this.pageOptions.page = 1
				this.loadData()
			},
			handleReset() {
				this.queryParams = {
					goodsTitle: '',
					goodsType: '',
					rowState: ''
				}
				this.shelfTimeRange = []
				this.activeStateTab = 'all'
				this.pageOptions.page = 1
				this.pageOptions.limit = 20
				this.loadData()
			},
			handleSizeChange(size) {
				this.pageOptions.page = 1
				this.pageOptions.limit = size
				this.loadData()
			},
			handleCurrentChange(page) {
				this.pageOptions.page = page
				this.loadData()
			},
			handleDetail(row) {
				this.$router.push({ path: '/mall/shop/goods-publish', query: { id: row.id, readonly: 1 } })
			},
			handleEdit(row) {
				this.$router.push({ path: '/mall/shop/goods-publish', query: { id: row.id } })
			},
			async handleUpdateState(row, rowState) {
				await updateMerchantGoodsState({ id: row.id, rowState })
				this.$message.success(rowState === 2 ? '删除成功' : '操作成功')
				this.loadData()
			},
			goodsTypeText(value) {
				return Number(value) === 1 ? '平台自营商品' : '展销商品'
			},
			handleStateTabChange(item) {
				this.activeStateTab = item.key
				this.queryParams.rowState = item.rowState
				this.pageOptions.page = 1
				this.loadData()
			},
			getGoodsImage(row) {
				const image = row.mainImage || row.mainImageId || row.coverFileId || row.fileRecordId || ''
				if (!image) return ''
				if (/^https?:\/\//.test(image) || image.indexOf('data:image') === 0) return image
				return previewMerchantFile() + image
			},
			categoryText(row) {
				return row.categoryThirdName || row.categorySecondName || row.categoryFirstName || row.categoryName || '-'
			},
			priceText(row) {
				if (!row.sellingPrice) return '-'
				return `¥ ${row.sellingPrice}`
			},
			goodsStatusText(row) {
				if (Number(row.rowState) === 8) return '售卖中'
				if (Number(row.rowState) === 9) return '已下架'
				if (Number(row.rowState) === 7) return '草稿'
				return this.rowStateText(row.rowState)
			},
			auditStatusText(row) {
				if (row.auditState === undefined || row.auditState === null || row.auditState === '') return '-'
				const auditState = Number(row.auditState)
				const map = {
					10: '待审核',
					1: '审核通过',
					2: '审核不通过'
				}
				return map[auditState] || '-'
			},
			statusClass(value) {
				const state = Number(value)
				if (state === 8) return 'success'
				if (state === 9) return 'off'
				if (state === 7) return 'draft'
				if (state === 3) return 'danger'
				return 'warning'
			},
			auditClass(row) {
				if (row.auditState === undefined || row.auditState === null || row.auditState === '') return 'draft'
				const state = Number(row.auditState)
				if (state === 1) return 'success'
				if (state === 2) return 'danger'
				if (state === 10) return 'warning'
				return 'draft'
			},
			orderStateText(value) {
				const state = String(value === undefined || value === null ? '' : value).toUpperCase()
				const map = {
					'0': '待支付',
					O: '待支付',
					'1': '已支付',
					'2': '已取消'
				}
				return map[state] || '-'
			},
			orderStateClass(value) {
				const state = String(value === undefined || value === null ? '' : value).toUpperCase()
				if (state === '1') return 'success'
				if (state === '2') return 'off'
				if (state === '0' || state === 'O') return 'warning'
				return 'draft'
			},
			timeText(row) {
				const value = row.shelfTime || row.publishTime || row.createTime || ''
				return value ? String(value) : '-'
			},
			rowStateText(value) {
				const map = {
					1: '待审核',
					3: '审核驳回',
					4: '审核通过',
					7: '草稿',
					8: '已上架',
					9: '已下架',
					2: '已删除'
				}
				return map[Number(value)] || '待审核'
			},
			rowStateTagType(value) {
				if (Number(value) === 8) return 'success'
				if (Number(value) === 9) return 'info'
				if (Number(value) === 2) return 'danger'
				return 'warning'
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import './shop.scss';
</style>
